import { render } from "./_Atualizar.vue?vue&type=template&id=4edfea60"
import script from "./_Atualizar.vue?vue&type=script&lang=ts"
export * from "./_Atualizar.vue?vue&type=script&lang=ts"
script.render = render

export default script